import { MOBILE_BREAKPOINT } from '../tokens';
import { useWindowSize } from './useWindowSize';

/** True when the viewport is at or below the mobile breakpoint. */
export function useIsMobile(): boolean {
  const { width } = useWindowSize();
  return width <= MOBILE_BREAKPOINT;
}
